import { render, staticRenderFns } from "./defaultEventSortingModal.vue?vue&type=template&id=ee22dd38&lang=pug&"
import script from "./defaultEventSortingModal.vue?vue&type=script&lang=js&"
export * from "./defaultEventSortingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports